import React from 'react'
import css from 'styled-jsx/css'
import { motion } from 'framer-motion'

const { className, styles } = css.resolve`
	div {
		height: 35px;
		width: 100%;
		text-align: center;
		font-weight: 600;
		font-size: var(--font--xs);
		color: var(--color-yellow);
		display: flex;
		align-items: center;
		justify-content: center;
	}
`

const EmailCaptureThanks = ({ submitted }) => {
	return (
		<>
			<motion.div className={className} animate={{ y: submitted ? 0 : -35 }}>
				Thanks!
			</motion.div>

			{styles}
		</>
	)
}

export default EmailCaptureThanks
